import { NavLink, Outlet, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/joy/Grid';

import Logo from '../assets/logo.svg'



export default function MainLayout() {
    const { t, i18n } = useTranslation();
    const [index, setIndex] = useState(0);
    const [openSubMenu, setOpenSubMenu] = useState(false);
    const navigate = useNavigate();
    const changeLang = (lang) => {
        i18n.changeLanguage(lang)
    };


    return (
        <Grid
            container
            rowSpacing={1}
            // columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            sx={{ width: '100%', backgroundColor:'#FBFBFB' }}
            alignContent='center'
        >
            <Grid xs={6}>
                <Outlet />
            </Grid>
            <Grid xs={6} sx={{textAlign:'center', display:'flex', alignContent:'center'}}>
                <img src={Logo} className='logoLogin' alt='logo' />
            </Grid>
        </Grid>
       
    )
}